import { WithAuthorization } from "../../context";
import { useSearchParams } from "react-router-dom";
import { OrganizationQuestionnaire } from "./index";

function OrganizationQuestionnaireWrapper() {
  const [searchParams] = useSearchParams();
  const questionnaireId = searchParams.get("id");

  return (
    <OrganizationQuestionnaire questionnaireId={questionnaireId} isOpenedInModal={false} />
  )
}

export default WithAuthorization(OrganizationQuestionnaireWrapper);